module.exports = __webpack_public_path__ + "img/decline.e961c6b9.png";